import { render } from "./list-choose-tag-custom-header.vue?vue&type=template&id=c07f0852&scoped=true&ts=true"
import script from "./list-choose-tag-custom-header.vue?vue&type=script&lang=ts"
export * from "./list-choose-tag-custom-header.vue?vue&type=script&lang=ts"

import "./list-choose-tag-custom-header.vue?vue&type=style&index=0&id=c07f0852&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07f0852"]])

export default __exports__